import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ManageClientPage from "./ManageClientPage";
import ViewClientDetails from "./ViewClient";
import MyClient from "./MyClient";

export default function ManageClientMainPage() {
  const params = useParams();
  const [ipoData, setIpoData] = useState(null);
  const naviagte=useNavigate()

  const handleIPONavigate = (data) => {
    setIpoData(data);
  };

  console.log("params",params)

  const handleNavigate=(url)=>{
    naviagte(url)
  }

  return (
    <div className="mt-[100px] p-6">
      {/* Simple Tabs Placeholder */}
      <div className="flex justify-center gap-4 mb-6">
        <button
        onClick={()=>handleNavigate("/manage-client/client")}
          className={`px-4 py-2 rounded ${
            params.name === "client" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
        >
          My Client
        </button>
        <button
        onClick={()=>handleNavigate("/manage-client/ipo-manage")}
          className={`px-4 py-2 rounded ${
            params.name === "ipo-manage" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
        >
          Manage IPO
        </button>
      </div>

      {/* Page Switcher */}
      {params.name === "client" && <MyClient />}

      {params.name === "ipo-manage" && (
        <>
          {ipoData ? (
            <ViewClientDetails ipoData={ipoData} setIpoData={setIpoData} />
          ) : (
            <ManageClientPage handleIPONavigate={handleIPONavigate} />
          )}
        </>
      )}
    </div>
  );
}
